// eslint-disable-next-line import/extensions
import Hex from 'crypto-js/enc-hex.js';
// eslint-disable-next-line import/extensions
import HmacSHA256 from 'crypto-js/hmac-sha256.js';
// eslint-disable-next-line import/extensions
import MD5 from 'crypto-js/md5.js';
// eslint-disable-next-line import/extensions
import SHA256 from 'crypto-js/sha256.js';

const md5 = (value) => MD5(value).toString();
const sha256 = (value) => SHA256(value).toString();

function ASCII(key, time) {
  const str = Object.values(key).reduce((total, item) => total + item, '') + md5(`${time}`);
  return sha256(str.split('').sort().join(''));
}

export function params(data, oauth, withOut) {
  const time = Math.round(new Date().getTime() / 1000);
  const o = {
    time,
    token: sha256(md5(process.env.VUE_APP_KEY + time)),
  };
  const apikeyData = { ...data };
  // 不参与加密的字段
  withOut?.forEach((item, index) => {
    delete apikeyData[item];
  });
  const apikey = {
    apikey: ASCII(apikeyData, time),
  };
  // 是否参与加密
  return oauth ? Object.assign(o, apikey, data) : Object.assign(o, data);
}

export function paramsPoints(data, oauth, withOut) {
  const time = Math.round(new Date().getTime() / 1000);
  const apikeyData = { ...data };
  // 不参与加密的字段
  withOut?.forEach((item, index) => {
    delete apikeyData[item];
  });
  const apikey = {
    apikey: ASCII(apikeyData, time),
  };
  // 是否参与加密
  return oauth ? Object.assign(apikey, data) : Object.assign(data);
}

export function encryptoData(data) {
  // 秘钥不存在直接返回
  if (process.server) {
    return data;
  }
  if (!document.documentElement.encrypt_info) {
    // 无法从 store 上报，避免引入循环；降级到 console 避免打断流程
    try {
      console.warn('signature-encryptoData: missing encrypt_info', {
        ua: navigator.userAgent,
        encrypt_info: document.documentElement.encrypt_info,
      });
    } catch {}
    return data;
  }
  const secretKey = document.documentElement.encrypt_info;
  // 需要加密的接口需要新增时间戳字段
  data.timestamp = parseInt(Date.now() / 1000);
  // 与后端达成一致，将对象的键按字母顺序排列
  const sortedKeys = Object.keys(data).sort();
  // 需要把参数拼接成 k1v1k2v2secret的格式
  let sortedParams = '';
  sortedKeys.forEach((key) => {
    // 接口请求的时候，会自动过滤掉值为undefined的参数
    if (data[key] !== undefined) {
      // 与后端达成一致，非字符串类型都转成json字符串
      sortedParams += `${key}${typeof data[key] !== 'string' ? JSON.stringify(data[key]) : data[key]}`;
    }
  });
  sortedParams += `secret${secretKey}`;
  // 将拼接好的参数进行HmacSHA256加密
  const hash = HmacSHA256(sortedParams, secretKey);
  // 转成16进制字符串
  const hexHash = hash.toString(Hex);
  // base64再加密
  const base64Hash = btoa(hexHash);
  // 需要加密的接口需要新增签名字段
  data.signature = base64Hash;
  return data;
}
